import { Card, Col, Container, Row } from 'react-bootstrap';
import './interestsPanelStyle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';

const InterestsPanel = ({ interests }) => {
  if (!interests || interests.length === 0) {
    return (
      <Card className="interestPanel mt-2">
        <Card.Body>
          <Container>
            <h3>Interests</h3>
            <Row>
              <Col>
                {/* <p className="no-interests-message">No interests available</p> */}
              </Col>
            </Row>
          </Container>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="interestPanel mt-2">
      <Card.Body>
        <Container>
          <h3>Interests</h3>
          <Row>
            {interests.map((interest, index) => (
              <Col lg={6} className="label" key={index}>
                <FontAwesomeIcon icon={faBullseye} />
                <span className="p-1">{interest}</span>
              </Col>
            ))}
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};

export default InterestsPanel;
